import { signal } from "@preact/signals-react"
import { useEffect } from "react"

import { addNotification } from "../stores/notification-store"
import { fetchUsers } from "../utils/api"

export const users = signal([])
export const error = signal(null)
export const loading = signal(false)
export const modified = signal(false) // allows a component to flag the data as modified so subsequent calls to the hook will reload it
export const parameterHash = signal(null)

const fetchData = async (businessEntityId, config, accessToken) => {

    const hash = await import('object-hash').then(module => module.default || module)
    // if any parameters have changed then flag as modified so that the hook will reload the data
    const currentParametersHash = hash([businessEntityId, config, accessToken])
    if (currentParametersHash != parameterHash.value) {
        modified.value = true
        parameterHash.value = currentParametersHash
    }

    // short-circuit if we have a pending request, are waiting for parameters or have already received an error
    if (loading.value || !businessEntityId || !config || !accessToken || error.value || !modified.value) {
        return
    }

    // short-circuit if we already have the data and it's not flagged as modified
    if (users.value.length && !modified.value) {
        return
    }
    
    try {
        loading.value = true
        users.value = await fetchUsers(businessEntityId, config, accessToken)
    }
    catch(err) {
        error.value = err
        console.log(err)
        addNotification(`Unable to load users due to the following error - ${err}`)
    }
    finally {
        loading.value = false
        modified.value = false
    }  
    
}

export default function useUsersList(businessEntityId, config, accessToken) {
    useEffect(() => {
        fetchData(businessEntityId, config, accessToken)
    }, [businessEntityId, config, accessToken])

    return {
        users, loading, error, modified, fetchData
    }
}